import { render, staticRenderFns } from "./CrewCard.vue?vue&type=template&id=64a143da&scoped=true&"
import script from "./CrewCard.vue?vue&type=script&lang=js&"
export * from "./CrewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a143da",
  null
  
)

export default component.exports